import { Spinner } from "reactstrap";
import FormField from "../ui/FormField";
import { Button } from "../Button";
import { X } from "lucide-react";

const BankInfoClient = ({ formData, setFormData, errors,isLoading, handelUpdate }) => {
    const onChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <div onClick={(e)=> e.stopPropagation()} className="bg-white w-4/5 md:w-3/5 p-2 rounded-lg z-50 max-h-[90vh] overflow-auto">
            <div className="flex flex-row items-center justify-between border-b border-b-gray-200 pb-2">
                <div className="text-lg font-semibold text-gray-900">Bank Details</div>
                <button
                    type="button"
                    onClick={() => setFormData(null)} 
                    className="bg-red-50 p-1rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
                >
                    <X/>
                </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                <FormField
                    label="Bank Name"
                    value={formData?.bankName}
                    onChange={(value) => onChange("bankName", value)}
                    placeholder="Enter bank name"
                    error={errors.bankName}
                    required
                />

                <FormField
                    label="Account Number"
                    type="text"
                    value={formData?.accountNumber}
                    // onChange={(value) => onChange("accountNumber", value)}
                    onChange={(value) => {
                        const digitsOnly = value.replace(/\D/g, "").slice(0, 18);
                        onChange("accountNumber", digitsOnly);
                    }}
                    placeholder="Enter account number"
                    error={errors?.accountNumber}
                    maxLength={18}
                    required
                />

                <FormField
                    label="IFSC Code"
                    value={formData?.ifscCode}
                    onChange={(value) => onChange("ifscCode", value)}
                    placeholder="SBIN0000123"
                    error={errors?.ifscCode}
                    maxLength={11}
                    required
                />

                <FormField
                    label="SWIFT Code"
                    value={formData?.swiftCode}
                    onChange={(value) => onChange("swiftCode", value)}
                    placeholder="Enter SWIFT code"
                    error={errors.swiftCode}

                />


                <FormField
                    label="Branch Address"
                    type="description"
                    value={formData?.branchAddress}
                    onChange={(value) => onChange("branchAddress", value)}
                    placeholder="Enter branch address"
                />
            </div>
            <div className='flex flex-row items-center justify-end gap-2'>
                <button
                    type="button"
                    onClick={() => setFormData(null)} 
                    className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
                >
                    Cancel
                </button>
                {isLoading ? 
                <Button label={<Spinner size={"sm"}/>}/> :
                <Button label="Update" type="button" onClick={(e)=> handelUpdate(e)} className="m-2"/>
                }
            </div>
        </div>
    );
};

export default BankInfoClient;